import React from "react";
import { ICLientDetails } from "..";
import Button from "../../../../../components/Button";
import { IconArrosDifs, IconCheckBold, IconPencilRevert, IconPeopleProjects, IconXBorder } from "../../../../../icons";
import { remask, unRemask } from "../../../../../libs/remask-mask";

export default function LeftScreen({
  client,
  handleClickNewProject,
  handleUpdateClient,
  handleStateClientClick,
}: {
  client: ICLientDetails;
  handleClickNewProject;
  handleUpdateClient;
  handleStateClientClick;
}) {
  function Header() {
    function renderName() {
      const nameNotHasSpace = !client?.name?.includes(" ");
      if (nameNotHasSpace) return client?.name.slice(0, 2).toUpperCase();
      const [firstName, secondName] = client?.name?.split(" ");
      return `${firstName[0]?.toUpperCase()}${secondName[0]?.toUpperCase()}`;
    }

    return (
      <div className="bg-primary flex justify-center items-center h-auto rounded-t-xl">
        {client?.img ? (
          <img className="max-w-full max-h-56 rounded-full flex-center text-xs" src={client?.img} />
        ) : (
          <h2 className="bg-white w-56 h-56 rounded-full justify-center items-center">
            <span className="text-primary font-bold font-familyPoppins text-8xl">{renderName()}</span>{" "}
          </h2>
        )}
      </div>
    );
  }

  function Status() {
    return (
      <div className="px-4 py-2 font-familyPoppins text-xl rounded-md">
        <span className={client?.isDeleted ? "text-gray-700 bg-gray-300 rounded-md" : "text-green-500 bg-green-50 rounded-md"}>
          {client?.isDeleted ? "Inativo" : "Ativo"}
        </span>
        <h2 className="py-2 font-familyRoboto text-4xl font-bold rounded-md">{client?.name}</h2>
      </div>
    );
  }

  function Contats() {
    return (
      <div className="font-familyRoboto text-2xl">
        <div className="px-4 py-3">
          <h2 className="font-bold">Telefone</h2>
          <span>{remask(client?.phone, unRemask(client?.phone)?.length < 11 ? ["(99) 9999-9999"] : ["(99) 9 9999-9999"])}</span>
        </div>
        <div className="px-4 py-3">
          <h2 className="font-bold">E-mail</h2>
          <span>{client?.email}</span>
        </div>
      </div>
    );
  }

  function Details() {
    function Row1() {
      return (
        <div className="w-full flex text-primary justify-between flex-row">
          <div className="space-x-2 items-center py-1 inline-flex">
            <span>{IconArrosDifs}</span>
            <h2 className="font-roboto">Projetos</h2>
          </div>
          <div className="items-center justify-center">
            <span className="flex mr-3 justify-center items-center h-7 w-7 rounded-sm bg-blueSky font-new-source-sans-pro text-2xl font-semibold text-white">
              {client?.totalProjects}
            </span>
          </div>
        </div>
      );
    }

    function Row2() {
      return (
        <div className="w-full flex text-primary justify-between flex-row">
          <div className="space-x-2 items-center py-1 inline-flex">
            <span>{IconArrosDifs}</span>
            <h2 className="font-roboto">Projetos Ativos</h2>
          </div>
          <div className="items-center justify-center">
            <span className="flex mr-3 justify-center items-center h-7 w-7 rounded-sm bg-blueSky font-new-source-sans-pro text-2xl font-semibold text-white">
              {client?.totalActivedProjects}
            </span>
          </div>
        </div>
      );
    }

    function Row3() {
      return (
        <div className="w-full flex text-primary justify-between flex-row">
          <div className="space-x-2 items-center py-1 inline-flex">
            <span className="mr-2">{IconCheckBold}</span>
            <h2 className="font-roboto">Projetos finalizados</h2>
          </div>
          <div className="items-center justify-center">
            <span className="flex mr-3 justify-center items-center h-7 w-7 rounded-sm bg-blueSky font-new-source-sans-pro text-2xl font-semibold text-white">
              {client?.totalCompletedProjects}
            </span>
          </div>
        </div>
      );
    }

    function Row4() {
      return (
        <div className="w-full flex text-primary justify-between flex-row">
          <div className="space-x-2 items-center py-1 inline-flex">
            <span className="mr-2">{IconCheckBold}</span>
            <h2 className="font-roboto">Projetos cancelados</h2>
          </div>
          <div className="items-center justify-center">
            <span className="flex mr-3 justify-center items-center h-7 w-7 rounded-sm bg-blueSky font-new-source-sans-pro text-2xl font-semibold text-white">
              {client?.totalCanceledProjects}
            </span>
          </div>
        </div>
      );
    }

    function Row5() {
      return (
        <div className="w-full flex text-primary justify-between flex-row">
          <div className="space-x-2 items-center py-1 inline-flex">
            <span>{IconPeopleProjects}</span>
            <h2 className="font-roboto">Profissionais no cliente</h2>
          </div>
          <div className="items-center justify-center">
            <span className="flex mr-3 justify-center items-center h-7 w-7 rounded-sm bg-blueSky font-new-source-sans-pro text-2xl font-semibold text-white">
              {client?.totalCompletedProjects}
            </span>
          </div>
        </div>
      );
    }
    return (
      <div className="px-4 py-2">
        <Row1 />
        <Row2 />
        <Row3 />
        <Row4 />
        <Row5 />
      </div>
    );
  }

  function SpecificData() {
    return (
      <div className="p-4 text-primary">
        <div className="box-row between font-familyRoboto text-2xl font-bold">
          <span className="items-center justify-center">Horas trabalhadas</span>
          <h2 className="text-5xl mr-1">{client?.hoursWorkedWeek}</h2>
        </div>
        <div className="justify-end space-x-2 font-new-source-sans-pro text-xl">
          <span>horas</span> <span>minutos</span>
        </div>
      </div>
    );
  }

  function Buttons() {
    return (
      <div className="w-full p-3 justify-center items-center flex-col">
        <button
          onClick={handleClickNewProject}
          className="w-full m-1 h-14 cursor-pointer rounded-md font-familyRoboto justify-center items-center text-2xl bg-primary max-w-none font-bold shadow-md text-primary transition duration-300 hover:ease-in filter hover:brightness-75"
        >
          <span className="arrow-difs-card-icon-contrast mr-2 -mt-1">{IconArrosDifs} </span> NOVO PROJETO
        </button>
        <button
          onClick={handleUpdateClient}
          className="w-full m-1 h-14 cursor-pointer rounded-md font-familyRoboto justify-center items-center border border-primary text-2xl max-w-none font-bold shadow-md text-primary transition duration-300 hover:ease-in filter hover:bg-gray-200"
        >
          <span className="mr-2 -mt-2">{IconPencilRevert} </span> EDITAR CLIENTE
        </button>
        <button
          onClick={handleStateClientClick}
          className={`w-full m-1 h-14 cursor-pointer rounded-md font-familyRoboto justify-center items-center border border-secondary text-2xl max-w-none font-bold shadow-md text-primary transition duration-300 hover:ease-in filter hover:bg-gray-200 ${
            client?.isDeleted ? "btn-active-client" : "btn-inactive-client"
          }`}
        >
          {client?.isDeleted ? (
            <>
              <span className="mr-2 -mt-1">{IconCheckBold} </span>
              <span>ATIVAR CLIENTE</span>
            </>
          ) : (
            <>
              <span className="mr-2 -mt-1">{IconXBorder} </span>
              <span>INATIVAR CLIENTE</span>
            </>
          )}
        </button>
      </div>
    );
  }

  return (
    <div className="inline-block min-w-300px h-full bg-white rounded-xl shadow">
      <Header />
      <hr />
      <Status />
      <hr />
      <Contats />
      <hr />
      <Details />
      <hr />
      <SpecificData />
      <hr />
      <Buttons />
    </div>
  );
}
